import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Card, Button } from '../../components/v2/V2Components';

/**
 * Landing page when the user abandons Stripe Checkout. No state changed.
 */
export default function SubscriptionCancel() {
  const navigate = useNavigate();

  return (
    <div className="max-w-md mx-auto p-4">
      <Card className="p-8 text-center">
        <XCircle className="w-12 h-12 mx-auto mb-4 text-[var(--text-secondary)]" />
        <h1 className="text-xl font-semibold text-[var(--text-main)] mb-2">Checkout canceled</h1>
        <p className="text-sm text-[var(--text-secondary)] mb-6">
          No charge was made and your plan is unchanged. You can upgrade any time.
        </p>
        <Button variant="primary" fullWidth onClick={() => navigate('/subscription')}>
          Back to plan &amp; usage
        </Button>
      </Card>
    </div>
  );
}
